'use client';

import Link from 'next/link';
import DataObjectIcon from '@mui/icons-material/DataObjectOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '48px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
              <DataObjectIcon style={{ color: 'var(--accent)', fontSize: '22px' }} />
              <div className="footer-heading">JSON Patch</div>
            </div>
            <p style={{ color: 'var(--fg-muted)', fontSize: 'var(--font-size-base)', lineHeight: '1.6' }}>
              Free online JSON Patch generator and RFC 6902 tool for developers.
              Fast, secure, and browser-based.
            </p>
          </div>

          <div>
            <div className="footer-heading">Resources</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link href="/docs" className="footer-link">Documentation</Link>
              <Link href="/examples" className="footer-link">Examples</Link>
              <Link href="/diff" className="footer-link">JSON Diff</Link>
              <Link href="/validate" className="footer-link">Validator</Link>
              <Link href="/guides" className="footer-link">Guides</Link>
              <Link href="/privacy" className="footer-link">Privacy</Link>
            </div>
          </div>

          <div>
            <div className="footer-heading">Operations</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link href="/operations/add" className="footer-link">Add</Link>
              <Link href="/operations/remove" className="footer-link">Remove</Link>
              <Link href="/operations/replace" className="footer-link">Replace</Link>
              <Link href="/operations/move" className="footer-link">Move</Link>
              <Link href="/operations/copy" className="footer-link">Copy</Link>
              <Link href="/operations/test" className="footer-link">Test</Link>
            </div>
          </div>

          <div>
            <div className="footer-heading">Standards</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="https://datatracker.ietf.org/doc/html/rfc6902" target="_blank" rel="noopener noreferrer" className="footer-link">
                RFC 6902 (JSON Patch)
              </a>
              <a href="https://datatracker.ietf.org/doc/html/rfc6901" target="_blank" rel="noopener noreferrer" className="footer-link">
                RFC 6901 (JSON Pointer)
              </a>
            </div>
          </div>

          <div>
            <div className="footer-heading">About</div>
            <p style={{ color: 'var(--fg-muted)', fontSize: 'var(--font-size-base)', lineHeight: '1.6' }}>
              All processing happens in your browser for privacy and security.
              No data is sent to any server.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '12px', fontSize: 'var(--font-size-sm)', color: 'var(--fg-muted)' }}>
              <ShieldOutlinedIcon style={{ fontSize: '16px' }} />
              <span>Cookie-free &amp; Privacy-focused</span>
            </div>
          </div>
        </div>

        <div style={{ margin: '32px 0', borderTop: '1px solid var(--border)' }} />

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <span style={{ color: 'var(--fg-muted)', fontSize: 'var(--font-size-base)' }} suppressHydrationWarning>
            © {currentYear} JSON Patch Online. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
